/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SecretManagerAccount } from './secretManagerAccount';


export interface ResourceSecretManagerCredentialsInfo { 
    grouping_key?: string;
    secret_manager_account?: SecretManagerAccount;
    secret_manager_path?: string;
    created_time?: Date;
    secret_manager_refresh_time?: Date;
    updated_time?: Date;
}
export namespace ResourceSecretManagerCredentialsInfo {
}


